import React from 'react'
import { useSelector } from 'react-redux';
import UserScreenSize from '../../common/useScreenSize/UserScreenSize';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

function Advertisment() {
    const { width } = UserScreenSize();
    const advertisementData = useSelector((state) => state?.auth?.advertisement_data);
    return (

        width < 900 ? <Swiper
            autoplay={{
                delay: 2000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            }
            }
            // pagination={{
            //     dynamicBullets: false,
            //     clickable: true,
            // }
            // }
            loop={true}

            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
        >
            <div className='flex gap-[10px] justify-between items-center max-md:!block max-md:gap-[6px]'>
                {advertisementData?.filter((data) => ["banner5"].includes(data?.category) || ["banner4"].includes(data?.category))?.map((item) => (
                    <SwiperSlide>
                        <div key={item.id} className="border mb-[15px] boxp bg-[#f0f0f038] max-w-[595px] h-[68px] max-xl:w-[48%] max-lg:h-[58px] max-md:w-[100%]" >
                            <a
                                key={item?.index}
                                href={item?.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={item?.image || "/default-image.jpg"}
                                    alt={item?.category || "Advertisement"}
                                />
                            </a>
                        </div></SwiperSlide>
                ))}
            </div>

        </Swiper > :
            <div className='flex gap-[10px] justify-between items-center max-md:!block max-md:gap-[6px]'>
                {
                    advertisementData.map((item) => {
                        if (
                            ["banner4"].includes(item?.category)
                        ) {
                            return (
                                <div key={item.id} className="border mb-[15px] boxp bg-[#f0f0f038] max-w-[595px] h-[68px] max-xl:w-[48%] max-lg:h-[58px] max-md:w-[100%]">
                                    <a
                                        key={item?.index}
                                        href={item?.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className=" "

                                    >
                                        <img
                                            className=""
                                            src={item?.image || "/default-image.jpg"}
                                            alt={item?.category || "Advertisement"}
                                        />
                                    </a>
                                </div>
                            );
                        }
                    })
                }
                {
                    advertisementData.map((item) => {
                        if (
                            ["banner5"].includes(item?.category)
                        ) {
                            return (
                                <div key={item.id} className="border mb-[15px] boxp bg-[#f0f0f038] max-w-[595px] h-[68px] max-xl:w-[48%] max-lg:h-[58px] max-md:w-[100%]" >
                                    <a
                                        key={item?.index}
                                        href={item?.url}
                                        target="_blank"
                                        rel="noopener noreferrer"


                                    >

                                        <img

                                            src={item?.image || "/default-image.jpg"}
                                            alt={item?.category || "Advertisement"}
                                        />
                                    </a>
                                </div>
                            );
                        }
                    })

                }

                {/* {advertisementData?.filter((item) => {
                    if (width >= 1390) {
                        return item?.category === "banner5";
                    }
                }).map((item) => {
                    if (
                        ["banner5"].includes(item?.category)
                    ) {
                        return (
                                <div className="border p-1 mb-[15px]">
                            <div key={item.id} className="2xl:max-w-[320px] xl:max-w-[250px] mb-[15px] m-0">
                                <a
                                    key={item?.index}
                                    href={item?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"

                                >
                                    <img
                                        src={item?.image || "/default-image.jpg"}
                                        alt={item?.category || "Advertisement"}
                                        className="min-w-[234px] max-w-[234px] h-[60px]"
                                    />
                                </a>
                            </div>
                </div>
                        );
                    }
                })} */}

            </div>
    )
}

export default Advertisment